var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  contentLoaderData: () => contentLoaderData,
  fullScreenLoaderBlackData: () => fullScreenLoaderBlackData,
  fullScreenLoaderWhiteData: () => fullScreenLoaderWhiteData,
  inlineLoaderColorData: () => inlineLoaderColorData,
  inlineLoaderDarkData: () => inlineLoaderDarkData,
  inlineLoaderLightData: () => inlineLoaderLightData,
  spinnerColorData: () => spinnerColorData,
  spinnerDarkData: () => spinnerDarkData,
  spinnerLightData: () => spinnerLightData
});

// src/animation-data/content-loader.ts
var contentLoaderData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 1.1.0", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 222,
  w: 430,
  h: 430,
  nm: "_Loading_square",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Layer 3 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [224.279, 227.214, 0], ix: 2 },
        a: { a: 0, k: [49.648, 52.604, 0], ix: 1 },
        s: { a: 0, k: [500, 500, 100], ix: 6 }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Group 2 - Contents - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-9.548, -8.116],
                    [12.213, 7.96],
                    [-12.659, 7.277],
                    [12.618, 4.454],
                    [2.352, -3.056],
                    [0.498, -2.699],
                    [9.977, 2.146],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [9.549, 8.115],
                    [-7.226, -4.71],
                    [16.161, -9.29],
                    [-10.839, -3.826],
                    [-1.674, 2.175],
                    [-0.787, 4.264],
                    [-9.596, -2.065],
                    [0, 0]
                  ],
                  v: [
                    [-19.358, 5.322],
                    [22.599, 11.997],
                    [9.696, 27.143],
                    [13.051, -1.568],
                    [13.922, -31.277],
                    [-5.688, -26.311],
                    [-8.89, -18.844],
                    [-22.552, -7.117],
                    [-32.1, -20.439]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.984313785329, 0.901960844152, 0.458823559331, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 7, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 196.029,
                    s: [0]
                  },
                  { t: 221.054813602665, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.4], y: [0] },
                    t: 165.999,
                    s: [0]
                  },
                  { t: 191.858524540165, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [49.648, 52.604], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.517647058824, 0.811764765721, 0.760784373564, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [17.548, 19.917], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 165.999,
                    s: [0, 0]
                  },
                  { t: 170.170047977665, s: [100, 100] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 165.165165165165,
      op: 222.722722722723,
      st: 165.165165165165,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Layer 6 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [229.967, 255.217, 0], ix: 2 },
        a: { a: 0, k: [48.039, 44.207, 0], ix: 1 },
        s: { a: 0, k: [500, 500, 100], ix: 6 }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Group 2 - Contents - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-5.419, -6],
                    [12.941, -9.498],
                    [-11.033, 22.987],
                    [9.29, -3.097],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [6.622, 7.33],
                    [-12.942, 9.497],
                    [11.032, -22.988],
                    [-9.29, 3.096],
                    [0, 0]
                  ],
                  v: [
                    [11.43, -26.475],
                    [14.719, -10.507],
                    [17.598, 16.978],
                    [-7.732, 0.288],
                    [-20.312, -22.893],
                    [-30.538, -12.025]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.196078446332, 0.364705882353, 0.576470588235, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 7, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 140.974,
                    s: [0]
                  },
                  { t: 161.828799176781, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.4], y: [0] },
                    t: 115.115,
                    s: [0]
                  },
                  { t: 136.803408551781, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [48.039, 44.439], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.705882352941, 0.400000029919, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [14.801, 44.726], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 115.115,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 120.12,
                    s: [100, 100]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 196.029,
                    s: [100, 100]
                  },
                  { t: 200.199892926781, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 114.280947614281,
      op: 200.2002002002,
      st: 114.280947614281,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Layer 4 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [197.76, 233.027, 0], ix: 2 },
        a: { a: 0, k: [47.397, 48.847, 0], ix: 1 },
        s: { a: 0, k: [500, 500, 100], ix: 6 }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Group 3 - Contents - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 3 - Contents - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 3 - Contents - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [20.129, -10.827],
                    [-26.542, -1.082],
                    [11.227, -3.364],
                    [3.097, 10.452],
                    [-7.882, 2.597]
                  ],
                  o: [
                    [0, 0],
                    [-20.355, 9.691],
                    [33.252, 1.354],
                    [-7.446, 2.231],
                    [-4.178, -14.1],
                    [0, 0]
                  ],
                  v: [
                    [22.774, 17.818],
                    [-3.742, 21.657],
                    [-3.355, 2.883],
                    [9.226, -17.247],
                    [-18.452, -17.247],
                    [7.774, -30.014]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0, 0.58431372549, 0.478431402468, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 7, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 85.919,
                    s: [0]
                  },
                  { t: 110.944703492555, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.4], y: [0] },
                    t: 55.889,
                    s: [0]
                  },
                  { t: 81.748414430055, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [47.397, 48.847], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.67, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [0.945098099054, 0.768627510819, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.183, 14.998], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 55.889,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 59.226,
                    s: [100, 100]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 140.974,
                    s: [100, 100]
                  },
                  { t: 145.144898805055, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 55.0550550550551,
      op: 145.145145145145,
      st: 55.0550550550551,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Layer 5 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [242.84, 220.002, 0], ix: 2 },
        a: { a: 0, k: [42.323, 44.529, 0], ix: 1 },
        s: { a: 0, k: [500, 500, 100], ix: 6 }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Group 2 - Contents - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Group 2 - Contents - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Transform - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [3.144, -9.317],
                    [-11.522, 11.368],
                    [11.612, -5.038],
                    [2.75, -9.989],
                    [-8.867, 1.58],
                    [-7.065, -5.935]
                  ],
                  o: [
                    [0, 0],
                    [-6.194, 18.348],
                    [8.806, -7.742],
                    [-7.152, 3.102],
                    [-2.283, 8.293],
                    [9.735, -1.736],
                    [0, 0]
                  ],
                  v: [
                    [-23.693, -27.029],
                    [-18.628, -14.835],
                    [16.016, 0.068],
                    [4.984, -13.862],
                    [-21.725, 12.017],
                    [-8.564, 25.449],
                    [14.178, 20.1]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 0.509803921569, 0, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 7, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 30.864,
                    s: [0]
                  },
                  { t: 51.71875, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.4], y: [0] },
                    t: 5.005,
                    s: [0]
                  },
                  { t: 26.693359375, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [42.322, 44.529], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.67, 0],
                    [1e-3, 5.669],
                    [-5.67, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.227450995352, 0.439215716194, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [66.038, 72.812], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 5.005,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 9.176,
                    s: [100, 100]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 85.919,
                    s: [100, 100]
                  },
                  { t: 90.08984375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.517647058824, 0.811764765721, 0.760784373564, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [6.51, 13.285], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 35.869,
                    s: [100, 100]
                  },
                  { t: 40.0400390625, s: [0, 0] }
                ],
                ix: 3
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 90.0900900900901,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/full-screen-loader-black.ts
var fullScreenLoaderBlackData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 29.9700012207031,
  ip: 0,
  op: 90.0000036657751,
  w: 1920,
  h: 1080,
  nm: "Xx-logo",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "1a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [960, 540, 0], ix: 2 },
        a: { a: 0, k: [479, 242.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 10,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 30.0000012219251,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [219.774, 484.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0],
                    [1.4, 0],
                    [12.7, 44.8],
                    [0, 0],
                    [17.1, 3],
                    [0, 0],
                    [0, 0.2],
                    [-0.2, 0],
                    [0, 0],
                    [0, 0],
                    [-7.9, -27.4],
                    [-9.6, -33.9],
                    [-12.9, -6.9],
                    [-1.8, -0.5],
                    [0, 0],
                    [0, -0.2]
                  ],
                  o: [
                    [-2.7, 0],
                    [-19.2, 0],
                    [0, 0],
                    [-6.8, -23.5],
                    [0, 0],
                    [-0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [0, 0],
                    [22.9, 0],
                    [0, 0],
                    [7.1, 25.1],
                    [2.1, 1.1],
                    [0, 0],
                    [0.2, 0],
                    [0.1, 0.2]
                  ],
                  v: [
                    [104.95, 242.2],
                    [98.45, 242.2],
                    [43.45, 187.6],
                    [-71.05, -203.3],
                    [-105.05, -241.5],
                    [-105.05, -241.5],
                    [-105.35, -241.8],
                    [-104.95, -242.2],
                    [-104.75, -242.2],
                    [-87.75, -242.2],
                    [-44.45, -203.3],
                    [71.05, 190],
                    [99.35, 239.1],
                    [104.95, 241.4],
                    [104.95, 241.4],
                    [105.25, 241.8]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [105.35, 242.7], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 15",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 10.0000004073083,
      op: 90.0000036657751,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "1b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.562, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 17.001,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 37.0012515070918,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [341.774, 484.762],
                      [341.774, -0.138]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 2, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Shape 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-3.6, 8.2],
                    [2.7, 9.6],
                    [0, 0],
                    [26.9, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [-8.1, -28],
                    [0, 0],
                    [-8.8, -8.3]
                  ],
                  o: [
                    [-4.6, -6.7],
                    [-3.9, -14],
                    [-9.3, -32.2],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [20.6, 3.2],
                    [0, 0],
                    [5.8, 20.5],
                    [6.3, -3.7]
                  ],
                  v: [
                    [95.7, 218.2],
                    [84.5, 193.9],
                    [-28, -190.2],
                    [-78.9, -235.9],
                    [-95.3, -235.9],
                    [-95.7, -235.5],
                    [-95.4, -235.1],
                    [-54.7, -190.1],
                    [57.9, 193.9],
                    [80.5, 235.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [144.1, 236.4], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 14",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 17.0012506924751,
      op: 90.0000036657752,
      st: 7.00125028516676,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "1c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.75, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 20.499,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 40.5000016495988,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [341.774, 484.762],
                      [341.774, -0.138]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [31.7, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-9.6, -33.2],
                    [-12.3, -42.2],
                    [-5.7, 19.4]
                  ],
                  o: [
                    [-10.9, -37.9],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [24.7, 3.5],
                    [0, 0],
                    [2.7, -9.1],
                    [-11.3, -38.8]
                  ],
                  v: [
                    [-8.95, -155.6],
                    [-68.75, -209.4],
                    [-84.15, -209.4],
                    [-84.55, -209],
                    [-84.25, -208.6],
                    [-84.25, -208.6],
                    [-35.55, -155.6],
                    [71.55, 209.4],
                    [84.55, 165.4]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [180.45, 209.6], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 13",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 20.5000008349821,
      op: 90.0000036657751,
      st: 10.5000004276738,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "2a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.312, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 30.749,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 39.7487516189998,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [471.8, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [-7.6, 6.2],
                    [-5.2, 17.4],
                    [-3.6, 13.3],
                    [-28.5, 6.9],
                    [-4.8, 0.5],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [15.9, -59.7],
                    [0.7, -2.6],
                    [12.3, -10],
                    [6.6, -1],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0]
                  ],
                  o: [
                    [0, 0],
                    [14.1, 0],
                    [12.3, -10],
                    [0.7, -2.6],
                    [11.9, -44.9],
                    [4.7, -1.2],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-37.6, 0],
                    [-5.7, 21.5],
                    [-5.2, 17.4],
                    [-5, 4.1],
                    [0, 0],
                    [-0.2, 0],
                    [-0.2, 0.3],
                    [0, 0]
                  ],
                  v: [
                    [-126.1, 242.35],
                    [-114.8, 242.35],
                    [-83, 232.45],
                    [-59.9, 188.45],
                    [44.7, -167.65],
                    [111.9, -239.05],
                    [126.2, -241.55],
                    [126.2, -241.55],
                    [126.5, -241.95],
                    [126.1, -242.35],
                    [113.6, -242.35],
                    [18.2, -167.75],
                    [-86.4, 188.35],
                    [-109.8, 234.15],
                    [-126, 241.45],
                    [-126, 241.45],
                    [-126.3, 241.85],
                    [-126.1, 242.35]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [345.3, 242.55], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 12",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 10.7487504378056,
      op: 90.0000036657751,
      st: 0.74875003049721,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "2b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.5, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 37.499,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 46.4987518939329,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [505.8, 485.3],
                      [505.8, 0.6]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0.1],
                    [13.1, -10.5],
                    [6, -22.6],
                    [0.8, -2.6],
                    [12.3, -10.1],
                    [8.9, -1.4],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [-7.6, 6.2],
                    [-5.2, 17.4],
                    [-0.7, 2.6],
                    [-13.3, 11.5],
                    [-4.2, 2.4]
                  ],
                  o: [
                    [-10.2, -2.9],
                    [-13.1, 10.5],
                    [-0.7, 2.6],
                    [-5.2, 17.4],
                    [-5.6, 4.6],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [14.1, 0],
                    [12.3, -10],
                    [0.8, -2.6],
                    [6.6, -24.7],
                    [3.9, -3.3],
                    [-0.2, -0.1]
                  ],
                  v: [
                    [109.15, -234.6],
                    [71.45, -226.2],
                    [40.65, -175.3],
                    [-64.75, 183.5],
                    [-87.85, 227.5],
                    [-109.35, 236.7],
                    [-109.35, 236.7],
                    [-109.65, 237.1],
                    [-109.25, 237.5],
                    [-92.95, 237.5],
                    [-61.15, 227.6],
                    [-38.05, 183.6],
                    [66.55, -172.5],
                    [97.55, -225.8],
                    [109.65, -234.4]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.170589104295, 0.506195306778, 0.349621683359, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [376.75, 247.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 11",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 37.7125015360616,
      op: 90.0000036657751,
      st: 7.49875030543035,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "2c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 40.248,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 49.2462520058409,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [517.8, 486.1],
                      [517.8, 1.4]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [4.6, 3.8],
                    [0, 0],
                    [6.6, -24.7],
                    [2.2, -7.4],
                    [31.6, -4.8],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [0, 0],
                    [-0.9, 0],
                    [-13.7, 46.6],
                    [-0.8, 2.7],
                    [-6.7, 13]
                  ],
                  o: [
                    [0, 0],
                    [-13.4, 11.5],
                    [-0.7, 2.6],
                    [-8.4, 28.2],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [32.1, -1.3],
                    [10, -34.1],
                    [3.9, -13],
                    [-1.4, -2.3]
                  ],
                  v: [
                    [84.9, -231.7],
                    [84.9, -231.7],
                    [53.8, -178.4],
                    [-48.5, 169.9],
                    [-95.5, 230.9],
                    [-95.5, 230.9],
                    [-95.8, 231.3],
                    [-95.4, 231.7],
                    [-93.8, 231.7],
                    [-89.1, 231.7],
                    [-83.7, 231.6],
                    [-21.8, 170],
                    [80.5, -178.3],
                    [95.8, -219.2]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [415.9, 253.3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 10",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 40.4587516479187,
      op: 90.0000036657751,
      st: 10.2462504173383,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "3a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.875, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 39.5,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 45.500001853253,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [669.8, 302],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [6.3, 4],
                    [9.7, 31],
                    [1.7, 5.6],
                    [16, 7.6],
                    [8.2, 0],
                    [3.9, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-18.3, -62],
                    [-7.4, -26.1],
                    [-33.3, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-7.6, -1.1],
                    [-14.8, -9.4],
                    [-0.8, -2.7],
                    [-10, -34.3],
                    [-9.7, -4.6],
                    [-5.3, 0],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [2.6, 0.4],
                    [18.3, 62],
                    [16, 56.6],
                    [0, 0]
                  ],
                  v: [
                    [95.35, 150.85],
                    [95.75, 150.45],
                    [95.45, 150.05],
                    [95.45, 150.05],
                    [74.65, 142.55],
                    [38.65, 83.95],
                    [-11.55, -86.65],
                    [-53.75, -144.95],
                    [-81.25, -150.85],
                    [-95.25, -150.85],
                    [-95.35, -150.85],
                    [-95.75, -150.45],
                    [-95.45, -150.05],
                    [-95.45, -150.05],
                    [-38.15, -86.55],
                    [9.55, 75.75],
                    [79.55, 150.85]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [574.05, 151.15], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 9",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 39.4612516072897,
      op: 90.0000036657751,
      st: 0.50000002036542,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "3b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.625, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 46.498,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 52.4962521382161,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [759.8, 301.5],
                      [759.8, -0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [6.3, 4],
                    [9.4, 28.6],
                    [3, 10.4],
                    [18.6, 6.9],
                    [7.3, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-5.6, -2.4],
                    [-10.4, -35.3],
                    [-1, -3.2],
                    [-14.4, -9.2],
                    [-12.1, 0],
                    [0, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-7.7, -1.1],
                    [-14.1, -9],
                    [-1.2, -3.8],
                    [-10.7, -36.5],
                    [-9.6, -3.5],
                    [-4.1, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [5.2, 0.7],
                    [17.3, 7.3],
                    [2.3, 7.9],
                    [9.6, 29.9],
                    [9.2, 5.8],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [97.65, 150.8],
                    [98.05, 150.4],
                    [97.75, 150],
                    [97.75, 150],
                    [76.75, 142.4],
                    [42.15, 87.6],
                    [-9.15, -86.6],
                    [-58.65, -146.3],
                    [-84.65, -150.9],
                    [-97.65, -150.9],
                    [-98.05, -150.5],
                    [-97.75, -150.1],
                    [-97.75, -150.1],
                    [-81.35, -145.6],
                    [-35.65, -86.6],
                    [15.05, 85.7],
                    [50.35, 142.6],
                    [82.05, 150.9],
                    [97.65, 150.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [624.85, 151.2], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 8",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 46.4537518921,
      op: 90.0000036657751,
      st: 7.49625030532852,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "3c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.75, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 48.995,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 54.9950022399923,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [759.8, 301.5],
                      [759.8, -0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [7.5, 25.2],
                    [17, 55.9],
                    [24.1, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-13.8, -46.9],
                    [-1.5, -4.4],
                    [-13.6, -8.9],
                    [-12.3, 0],
                    [0, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-21.1, -2.7],
                    [-7.9, -26.5],
                    [-17.1, -56.1],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [22.5, 3],
                    [12.1, 41.2],
                    [9.2, 27.3],
                    [9.2, 6],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [95.05, 150.8],
                    [95.45, 150.4],
                    [95.15, 150],
                    [95.15, 150],
                    [52.85, 92.4],
                    [-0.65, -86.7],
                    [-95.05, -150.9],
                    [-95.05, -150.9],
                    [-95.45, -150.5],
                    [-95.15, -150.1],
                    [-95.15, -150.1],
                    [-26.95, -86.6],
                    [25.05, 89.7],
                    [58.75, 142.4],
                    [90.75, 150.9],
                    [95.05, 150.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [669.05, 151.2], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 7",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 48.9512519938253,
      op: 90.0000036657751,
      st: 9.9950004071047,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "4a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.75, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 52.495,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 57.4950023418194,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.5, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.1, -3.2],
                    [0, 0],
                    [-24.7, 3.5],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [11, -37.9],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [9.6, -33.2],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-31.6, 0],
                    [0, 0],
                    [0, 0.1]
                  ],
                  v: [
                    [-47.4, 125.25],
                    [11.6, -71.45],
                    [60.3, -124.45],
                    [60.3, -124.45],
                    [60.6, -124.85],
                    [60.2, -125.25],
                    [44.8, -125.25],
                    [-15, -71.55],
                    [-60.6, 81.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [781.9, 125.45], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 6",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 17.495000712586,
      op: 90.0000036657751,
      st: 7.49500030527761,
      bm: 0
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: "4b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 54.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 59.7475024335656,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [936.75, 302.4],
                      [936.5, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0],
                    [0, 0],
                    [9.4, -32.2],
                    [0.5, -1.7],
                    [5.4, -8.6],
                    [-5.3, -1],
                    [-7.5, 24.5],
                    [0, 0],
                    [-20.6, 3.2],
                    [0, 0],
                    [0, 0.2]
                  ],
                  o: [
                    [0, 0],
                    [-26.9, 0],
                    [0, 0],
                    [-4.3, 13.8],
                    [5.1, 7],
                    [10.1, -8.7],
                    [0.4, -1.3],
                    [8.1, -27.9],
                    [0, 0],
                    [0.2, 0],
                    [0.1, -0.1]
                  ],
                  v: [
                    [70.45, -145.4],
                    [54.05, -145.4],
                    [3.15, -99.7],
                    [-55.75, 97.2],
                    [-70.85, 133],
                    [-54.95, 145.4],
                    [-28.85, 96.1],
                    [29.75, -99.7],
                    [70.45, -144.7],
                    [70.45, -144.7],
                    [70.75, -145.1]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.170589104295, 0.506195306778, 0.349621683359, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [819.35, 145.9], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 5",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 19.7475008043322,
      op: 90.0000036657751,
      st: 9.74750039702382,
      bm: 0
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: "4c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 55.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 60.7475024742964,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [936.75, 302.4],
                      [936.5, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [0, 0],
                    [7.9, -27.4],
                    [14.2, -47],
                    [19.3, -3.3],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [-11.8, 39.4],
                    [0, 0],
                    [-5.4, 1.7]
                  ],
                  o: [
                    [0.1, 0],
                    [0, -0.2],
                    [0, 0],
                    [0, 0],
                    [-22.9, 0],
                    [0, 0],
                    [-14.2, 47.1],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [33.6, 0],
                    [9.9, -33],
                    [1.6, -5.4],
                    [0, 0]
                  ],
                  v: [
                    [75.3, -150.1],
                    [75.6, -150.5],
                    [75.2, -150.9],
                    [75.2, -150.9],
                    [71.5, -150.9],
                    [28.2, -112],
                    [-31.1, 86.9],
                    [-74.3, 149.9],
                    [-75.3, 150.1],
                    [-75.6, 150.5],
                    [-75.2, 150.9],
                    [-62.1, 150.9],
                    [-4.2, 89.1],
                    [63.6, -137.4],
                    [75.3, -150.1]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [849.4, 151], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 4",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 55.6950022685039,
      op: 90.0000036657751,
      st: 10.7475004377546,
      bm: 0
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: "5a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 52.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.888, 1.3],
                      [844.4, 0.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 63.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [844.277, 378.168],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 80.9925032988922,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.688, 484.3],
                      [844.2, 483.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-9, 30.7],
                    [0, 0],
                    [5.9, -19.7],
                    [-9.9, 0],
                    [-7.6, 0],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-13.6, 45.6]
                  ],
                  o: [
                    [0, 0],
                    [-12, 39.6],
                    [-16.4, 55.1],
                    [1.3, 0],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-11.3, -2.7],
                    [-0.1, 0.2]
                  ],
                  v: [
                    [38.3, -86.25],
                    [11.9, -86.25],
                    [-21.9, 25.55],
                    [-2.5, 86.25],
                    [18.4, 86.25],
                    [18.4, 86.25],
                    [18.8, 85.85],
                    [18.5, 85.45],
                    [18.5, 85.45],
                    [5.4, 25.45]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [731.9, 398.05], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 12.9925005291954,
      op: 90.0000036657752,
      st: 2.99250012188702,
      bm: 0
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: "5b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.5, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 55.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.888, 1.3],
                      [844.4, 0.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 66.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [844.277, 378.168],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 83.9925034210847,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [698.75, 0.6],
                      [698.688, 484.1],
                      [844.2, 483.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [13.6, -1.8],
                    [0, 0],
                    [-8.4, 0],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-11.4, 38.2],
                    [-11, 37.5]
                  ],
                  o: [
                    [-9.3, 31.6],
                    [-14, 46.8],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-9.6, -2.5],
                    [0, 0],
                    [-6.3, 6.5]
                  ],
                  v: [
                    [9.55, -79.5],
                    [-26.15, 42.1],
                    [-9.65, 93.7],
                    [10.75, 93.7],
                    [11.15, 93.3],
                    [10.85, 92.9],
                    [10.85, 92.9],
                    [0.15, 42],
                    [40.15, -93.7]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [787.25, 390.7], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 15.9925006513879,
      op: 90.0000036657752,
      st: 5.99250024407953,
      bm: 0
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: "5c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.5, 298, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 60.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [824.75, 0.8],
                      [824.888, 1.3],
                      [964.4, 0.7],
                      [964.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 71.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [968.277, 378.336],
                      [968.263, 0.368]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 88.7475036147598,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [698.75, 0.6],
                      [698.688, 484.1],
                      [966.2, 483.4],
                      [966.263, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-9.5, 31.9],
                    [-6.3, 21.6],
                    [13.6, 2],
                    [0.1, -0.3],
                    [-0.1, 0],
                    [1.6, -5.6],
                    [0, 0],
                    [-7.1, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-8.1, -2.3],
                    [0, 0],
                    [6.3, -21.6],
                    [-0.1, 0],
                    [-0.1, 0.3],
                    [2.7, 1.4],
                    [-1.6, 5.6],
                    [-11.9, 39.8],
                    [0, 0]
                  ],
                  v: [
                    [-32.237, 242],
                    [-31.837, 241.6],
                    [-32.137, 241.2],
                    [-32.137, 241.2],
                    [-40.837, 198],
                    [77.463, -204.8],
                    [55.063, -241.9],
                    [54.463, -241.7],
                    [54.863, -241.2],
                    [58.963, -230.9],
                    [-67.037, 198.1],
                    [-53.037, 242]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.083593614399, 0.077463172376, 0.065477468073, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [878.837, 242.4], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 60.6900024719544,
      op: 90.0000036657751,
      st: 10.7475004377546,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/full-screen-loader-white.ts
var fullScreenLoaderWhiteData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 29.9700012207031,
  ip: 0,
  op: 90.0000036657751,
  w: 1920,
  h: 1080,
  nm: "Xx-logo 2",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "1a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [960, 540, 0], ix: 2 },
        a: { a: 0, k: [479, 242.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 10,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 30.0000012219251,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [219.774, 484.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0],
                    [1.4, 0],
                    [12.7, 44.8],
                    [0, 0],
                    [17.1, 3],
                    [0, 0],
                    [0, 0.2],
                    [-0.2, 0],
                    [0, 0],
                    [0, 0],
                    [-7.9, -27.4],
                    [-9.6, -33.9],
                    [-12.9, -6.9],
                    [-1.8, -0.5],
                    [0, 0],
                    [0, -0.2]
                  ],
                  o: [
                    [-2.7, 0],
                    [-19.2, 0],
                    [0, 0],
                    [-6.8, -23.5],
                    [0, 0],
                    [-0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [0, 0],
                    [22.9, 0],
                    [0, 0],
                    [7.1, 25.1],
                    [2.1, 1.1],
                    [0, 0],
                    [0.2, 0],
                    [0.1, 0.2]
                  ],
                  v: [
                    [104.95, 242.2],
                    [98.45, 242.2],
                    [43.45, 187.6],
                    [-71.05, -203.3],
                    [-105.05, -241.5],
                    [-105.05, -241.5],
                    [-105.35, -241.8],
                    [-104.95, -242.2],
                    [-104.75, -242.2],
                    [-87.75, -242.2],
                    [-44.45, -203.3],
                    [71.05, 190],
                    [99.35, 239.1],
                    [104.95, 241.4],
                    [104.95, 241.4],
                    [105.25, 241.8]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [105.35, 242.7], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 15",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 10.0000004073083,
      op: 90.0000036657751,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "1b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.562, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 17.001,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 37.0012515070918,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [341.774, 484.762],
                      [341.774, -0.138]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 2, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Shape 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-3.6, 8.2],
                    [2.7, 9.6],
                    [0, 0],
                    [26.9, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [-8.1, -28],
                    [0, 0],
                    [-8.8, -8.3]
                  ],
                  o: [
                    [-4.6, -6.7],
                    [-3.9, -14],
                    [-9.3, -32.2],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [20.6, 3.2],
                    [0, 0],
                    [5.8, 20.5],
                    [6.3, -3.7]
                  ],
                  v: [
                    [95.7, 218.2],
                    [84.5, 193.9],
                    [-28, -190.2],
                    [-78.9, -235.9],
                    [-95.3, -235.9],
                    [-95.7, -235.5],
                    [-95.4, -235.1],
                    [-54.7, -190.1],
                    [57.9, 193.9],
                    [80.5, 235.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [144.1, 236.4], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 14",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 17.0012506924751,
      op: 90.0000036657752,
      st: 7.00125028516676,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "1c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.75, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 0.833 },
                o: { x: 0.5, y: 0 },
                t: 20.499,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0.774, 1],
                      [220.548, 0.6],
                      [219.774, -0.301]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 40.5000016495988,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [0, 0.1],
                      [0, 485],
                      [341.774, 484.762],
                      [341.774, -0.138]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [31.7, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-9.6, -33.2],
                    [-12.3, -42.2],
                    [-5.7, 19.4]
                  ],
                  o: [
                    [-10.9, -37.9],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [24.7, 3.5],
                    [0, 0],
                    [2.7, -9.1],
                    [-11.3, -38.8]
                  ],
                  v: [
                    [-8.95, -155.6],
                    [-68.75, -209.4],
                    [-84.15, -209.4],
                    [-84.55, -209],
                    [-84.25, -208.6],
                    [-84.25, -208.6],
                    [-35.55, -155.6],
                    [71.55, 209.4],
                    [84.55, 165.4]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [180.45, 209.6], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 13",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 20.5000008349821,
      op: 90.0000036657751,
      st: 10.5000004276738,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "2a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.312, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 30.749,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 39.7487516189998,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [471.8, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [-7.6, 6.2],
                    [-5.2, 17.4],
                    [-3.6, 13.3],
                    [-28.5, 6.9],
                    [-4.8, 0.5],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [15.9, -59.7],
                    [0.7, -2.6],
                    [12.3, -10],
                    [6.6, -1],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0]
                  ],
                  o: [
                    [0, 0],
                    [14.1, 0],
                    [12.3, -10],
                    [0.7, -2.6],
                    [11.9, -44.9],
                    [4.7, -1.2],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-37.6, 0],
                    [-5.7, 21.5],
                    [-5.2, 17.4],
                    [-5, 4.1],
                    [0, 0],
                    [-0.2, 0],
                    [-0.2, 0.3],
                    [0, 0]
                  ],
                  v: [
                    [-126.1, 242.35],
                    [-114.8, 242.35],
                    [-83, 232.45],
                    [-59.9, 188.45],
                    [44.7, -167.65],
                    [111.9, -239.05],
                    [126.2, -241.55],
                    [126.2, -241.55],
                    [126.5, -241.95],
                    [126.1, -242.35],
                    [113.6, -242.35],
                    [18.2, -167.75],
                    [-86.4, 188.35],
                    [-109.8, 234.15],
                    [-126, 241.45],
                    [-126, 241.45],
                    [-126.3, 241.85],
                    [-126.1, 242.35]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [345.3, 242.55], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 12",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 10.7487504378056,
      op: 90.0000036657751,
      st: 0.74875003049721,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "2b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.5, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 37.499,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 46.4987518939329,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [505.8, 485.3],
                      [505.8, 0.6]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0.1],
                    [13.1, -10.5],
                    [6, -22.6],
                    [0.8, -2.6],
                    [12.3, -10.1],
                    [8.9, -1.4],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [-7.6, 6.2],
                    [-5.2, 17.4],
                    [-0.7, 2.6],
                    [-13.3, 11.5],
                    [-4.2, 2.4]
                  ],
                  o: [
                    [-10.2, -2.9],
                    [-13.1, 10.5],
                    [-0.7, 2.6],
                    [-5.2, 17.4],
                    [-5.6, 4.6],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [14.1, 0],
                    [12.3, -10],
                    [0.8, -2.6],
                    [6.6, -24.7],
                    [3.9, -3.3],
                    [-0.2, -0.1]
                  ],
                  v: [
                    [109.15, -234.6],
                    [71.45, -226.2],
                    [40.65, -175.3],
                    [-64.75, 183.5],
                    [-87.85, 227.5],
                    [-109.35, 236.7],
                    [-109.35, 236.7],
                    [-109.65, 237.1],
                    [-109.25, 237.5],
                    [-92.95, 237.5],
                    [-61.15, 227.6],
                    [-38.05, 183.6],
                    [66.55, -172.5],
                    [97.55, -225.8],
                    [109.65, -234.4]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [376.75, 247.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 11",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 37.7125015360616,
      op: 90.0000036657751,
      st: 7.49875030543035,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "2c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.25, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 40.248,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [219.155, 484.95],
                      [218.917, 484.9],
                      [471.8, 484.9],
                      [470.85, 484.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 49.2462520058409,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [218.917, 0.2],
                      [218.917, 484.9],
                      [517.8, 486.1],
                      [517.8, 1.4]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [4.6, 3.8],
                    [0, 0],
                    [6.6, -24.7],
                    [2.2, -7.4],
                    [31.6, -4.8],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [0, 0],
                    [-0.9, 0],
                    [-13.7, 46.6],
                    [-0.8, 2.7],
                    [-6.7, 13]
                  ],
                  o: [
                    [0, 0],
                    [-13.4, 11.5],
                    [-0.7, 2.6],
                    [-8.4, 28.2],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [32.1, -1.3],
                    [10, -34.1],
                    [3.9, -13],
                    [-1.4, -2.3]
                  ],
                  v: [
                    [84.9, -231.7],
                    [84.9, -231.7],
                    [53.8, -178.4],
                    [-48.5, 169.9],
                    [-95.5, 230.9],
                    [-95.5, 230.9],
                    [-95.8, 231.3],
                    [-95.4, 231.7],
                    [-93.8, 231.7],
                    [-89.1, 231.7],
                    [-83.7, 231.6],
                    [-21.8, 170],
                    [80.5, -178.3],
                    [95.8, -219.2]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [415.9, 253.3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 10",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 40.4587516479187,
      op: 90.0000036657751,
      st: 10.2462504173383,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "3a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.875, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 39.5,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 45.500001853253,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [669.8, 302],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [6.3, 4],
                    [9.7, 31],
                    [1.7, 5.6],
                    [16, 7.6],
                    [8.2, 0],
                    [3.9, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-18.3, -62],
                    [-7.4, -26.1],
                    [-33.3, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-7.6, -1.1],
                    [-14.8, -9.4],
                    [-0.8, -2.7],
                    [-10, -34.3],
                    [-9.7, -4.6],
                    [-5.3, 0],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [2.6, 0.4],
                    [18.3, 62],
                    [16, 56.6],
                    [0, 0]
                  ],
                  v: [
                    [95.35, 150.85],
                    [95.75, 150.45],
                    [95.45, 150.05],
                    [95.45, 150.05],
                    [74.65, 142.55],
                    [38.65, 83.95],
                    [-11.55, -86.65],
                    [-53.75, -144.95],
                    [-81.25, -150.85],
                    [-95.25, -150.85],
                    [-95.35, -150.85],
                    [-95.75, -150.45],
                    [-95.45, -150.05],
                    [-95.45, -150.05],
                    [-38.15, -86.55],
                    [9.55, 75.75],
                    [79.55, 150.85]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [574.05, 151.15], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 9",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 39.4612516072897,
      op: 90.0000036657751,
      st: 0.50000002036542,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "3b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.625, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 46.498,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 52.4962521382161,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [759.8, 301.5],
                      [759.8, -0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [6.3, 4],
                    [9.4, 28.6],
                    [3, 10.4],
                    [18.6, 6.9],
                    [7.3, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-5.6, -2.4],
                    [-10.4, -35.3],
                    [-1, -3.2],
                    [-14.4, -9.2],
                    [-12.1, 0],
                    [0, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-7.7, -1.1],
                    [-14.1, -9],
                    [-1.2, -3.8],
                    [-10.7, -36.5],
                    [-9.6, -3.5],
                    [-4.1, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [5.2, 0.7],
                    [17.3, 7.3],
                    [2.3, 7.9],
                    [9.6, 29.9],
                    [9.2, 5.8],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [97.65, 150.8],
                    [98.05, 150.4],
                    [97.75, 150],
                    [97.75, 150],
                    [76.75, 142.4],
                    [42.15, 87.6],
                    [-9.15, -86.6],
                    [-58.65, -146.3],
                    [-84.65, -150.9],
                    [-97.65, -150.9],
                    [-98.05, -150.5],
                    [-97.75, -150.1],
                    [-97.75, -150.1],
                    [-81.35, -145.6],
                    [-35.65, -86.6],
                    [15.05, 85.7],
                    [50.35, 142.6],
                    [82.05, 150.9],
                    [97.65, 150.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [624.85, 151.2], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 8",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 46.4537518921,
      op: 90.0000036657751,
      st: 7.49625030532852,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "3c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.75, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 48.995,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [477.475, 0],
                      [668.975, 0],
                      [669.8, 0.3]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 54.9950022399923,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [478.3, 0.3],
                      [478.3, 302],
                      [759.8, 301.5],
                      [759.8, -0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [7.5, 25.2],
                    [17, 55.9],
                    [24.1, 0],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, -0.1],
                    [0, 0],
                    [-13.8, -46.9],
                    [-1.5, -4.4],
                    [-13.6, -8.9],
                    [-12.3, 0],
                    [0, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-21.1, -2.7],
                    [-7.9, -26.5],
                    [-17.1, -56.1],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [22.5, 3],
                    [12.1, 41.2],
                    [9.2, 27.3],
                    [9.2, 6],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [95.05, 150.8],
                    [95.45, 150.4],
                    [95.15, 150],
                    [95.15, 150],
                    [52.85, 92.4],
                    [-0.65, -86.7],
                    [-95.05, -150.9],
                    [-95.05, -150.9],
                    [-95.45, -150.5],
                    [-95.15, -150.1],
                    [-95.15, -150.1],
                    [-26.95, -86.6],
                    [25.05, 89.7],
                    [58.75, 142.4],
                    [90.75, 150.9],
                    [95.05, 150.9]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [669.05, 151.2], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 7",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 48.9512519938253,
      op: 90.0000036657751,
      st: 9.9950004071047,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "4a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.75, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 52.495,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 57.4950023418194,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.5, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.1, -3.2],
                    [0, 0],
                    [-24.7, 3.5],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [11, -37.9],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [9.6, -33.2],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-31.6, 0],
                    [0, 0],
                    [0, 0.1]
                  ],
                  v: [
                    [-47.4, 125.25],
                    [11.6, -71.45],
                    [60.3, -124.45],
                    [60.3, -124.45],
                    [60.6, -124.85],
                    [60.2, -125.25],
                    [44.8, -125.25],
                    [-15, -71.55],
                    [-60.6, 81.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [781.9, 125.45], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 6",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 17.495000712586,
      op: 90.0000036657751,
      st: 7.49500030527761,
      bm: 0
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: "4b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 54.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 59.7475024335656,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [936.75, 302.4],
                      [936.5, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.2, 0],
                    [0, 0],
                    [9.4, -32.2],
                    [0.5, -1.7],
                    [5.4, -8.6],
                    [-5.3, -1],
                    [-7.5, 24.5],
                    [0, 0],
                    [-20.6, 3.2],
                    [0, 0],
                    [0, 0.2]
                  ],
                  o: [
                    [0, 0],
                    [-26.9, 0],
                    [0, 0],
                    [-4.3, 13.8],
                    [5.1, 7],
                    [10.1, -8.7],
                    [0.4, -1.3],
                    [8.1, -27.9],
                    [0, 0],
                    [0.2, 0],
                    [0.1, -0.1]
                  ],
                  v: [
                    [70.45, -145.4],
                    [54.05, -145.4],
                    [3.15, -99.7],
                    [-55.75, 97.2],
                    [-70.85, 133],
                    [-54.95, 145.4],
                    [-28.85, 96.1],
                    [29.75, -99.7],
                    [70.45, -144.7],
                    [70.45, -144.7],
                    [70.75, -145.1]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [819.35, 145.9], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 5",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 19.7475008043322,
      op: 90.0000036657751,
      st: 9.74750039702382,
      bm: 0
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: "4c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 1, y: 0 },
                t: 55.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.55, 302.4],
                      [663.55, 302.9],
                      [842.75, 302.7],
                      [842.75, 302.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 60.7475024742964,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [663.3, 0.4],
                      [663.55, 302.9],
                      [936.75, 302.4],
                      [936.5, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0],
                    [0, 0],
                    [0, 0],
                    [7.9, -27.4],
                    [14.2, -47],
                    [19.3, -3.3],
                    [0, 0],
                    [0, -0.2],
                    [-0.2, 0],
                    [0, 0],
                    [-11.8, 39.4],
                    [0, 0],
                    [-5.4, 1.7]
                  ],
                  o: [
                    [0.1, 0],
                    [0, -0.2],
                    [0, 0],
                    [0, 0],
                    [-22.9, 0],
                    [0, 0],
                    [-14.2, 47.1],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0.2],
                    [0, 0],
                    [33.6, 0],
                    [9.9, -33],
                    [1.6, -5.4],
                    [0, 0]
                  ],
                  v: [
                    [75.3, -150.1],
                    [75.6, -150.5],
                    [75.2, -150.9],
                    [75.2, -150.9],
                    [71.5, -150.9],
                    [28.2, -112],
                    [-31.1, 86.9],
                    [-74.3, 149.9],
                    [-75.3, 150.1],
                    [-75.6, 150.5],
                    [-75.2, 150.9],
                    [-62.1, 150.9],
                    [-4.2, 89.1],
                    [63.6, -137.4],
                    [75.3, -150.1]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [849.4, 151], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 4",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 55.6950022685039,
      op: 90.0000036657751,
      st: 10.7475004377546,
      bm: 0
    },
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: "5a",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 52.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.888, 1.3],
                      [844.4, 0.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 63.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [844.277, 378.168],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 80.9925032988922,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.688, 484.3],
                      [844.2, 483.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-9, 30.7],
                    [0, 0],
                    [5.9, -19.7],
                    [-9.9, 0],
                    [-7.6, 0],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-13.6, 45.6]
                  ],
                  o: [
                    [0, 0],
                    [-12, 39.6],
                    [-16.4, 55.1],
                    [1.3, 0],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-11.3, -2.7],
                    [-0.1, 0.2]
                  ],
                  v: [
                    [38.3, -86.25],
                    [11.9, -86.25],
                    [-21.9, 25.55],
                    [-2.5, 86.25],
                    [18.4, 86.25],
                    [18.4, 86.25],
                    [18.8, 85.85],
                    [18.5, 85.45],
                    [18.5, 85.45],
                    [5.4, 25.45]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [731.9, 398.05], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 12.9925005291954,
      op: 90.0000036657752,
      st: 2.99250012188702,
      bm: 0
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: "5b",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [481.5, 297.5, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 55.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.888, 1.3],
                      [844.4, 0.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 66.993,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [844.277, 378.168],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 83.9925034210847,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [698.75, 0.6],
                      [698.688, 484.1],
                      [844.2, 483.7],
                      [844.263, 0.2]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [13.6, -1.8],
                    [0, 0],
                    [-8.4, 0],
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-11.4, 38.2],
                    [-11, 37.5]
                  ],
                  o: [
                    [-9.3, 31.6],
                    [-14, 46.8],
                    [0, 0],
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-9.6, -2.5],
                    [0, 0],
                    [-6.3, 6.5]
                  ],
                  v: [
                    [9.55, -79.5],
                    [-26.15, 42.1],
                    [-9.65, 93.7],
                    [10.75, 93.7],
                    [11.15, 93.3],
                    [10.85, 92.9],
                    [10.85, 92.9],
                    [0.15, 42],
                    [40.15, -93.7]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [787.25, 390.7], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 15.9925006513879,
      op: 90.0000036657752,
      st: 5.99250024407953,
      bm: 0
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: "5c",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [480.5, 298, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "a",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0.833, y: 1 },
                o: { x: 0.8, y: 0 },
                t: 60.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [824.75, 0.8],
                      [824.888, 1.3],
                      [964.4, 0.7],
                      [964.263, 0.2]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0, y: 1 },
                o: { x: 0.167, y: 0 },
                t: 71.748,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [704.75, 0.8],
                      [704.764, 378.768],
                      [968.277, 378.336],
                      [968.263, 0.368]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 88.7475036147598,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [698.75, 0.6],
                      [698.688, 484.1],
                      [966.2, 483.4],
                      [966.263, -0.1]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 1
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1"
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0.2],
                    [0.2, 0.1],
                    [0, 0],
                    [-9.5, 31.9],
                    [-6.3, 21.6],
                    [13.6, 2],
                    [0.1, -0.3],
                    [-0.1, 0],
                    [1.6, -5.6],
                    [0, 0],
                    [-7.1, 0]
                  ],
                  o: [
                    [0.2, 0],
                    [0, -0.2],
                    [0, 0],
                    [-8.1, -2.3],
                    [0, 0],
                    [6.3, -21.6],
                    [-0.1, 0],
                    [-0.1, 0.3],
                    [2.7, 1.4],
                    [-1.6, 5.6],
                    [-11.9, 39.8],
                    [0, 0]
                  ],
                  v: [
                    [-32.237, 242],
                    [-31.837, 241.6],
                    [-32.137, 241.2],
                    [-32.137, 241.2],
                    [-40.837, 198],
                    [77.463, -204.8],
                    [55.063, -241.9],
                    [54.463, -241.7],
                    [54.863, -241.2],
                    [58.963, -230.9],
                    [-67.037, 198.1],
                    [-53.037, 242]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [878.837, 242.4], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 60.6900024719544,
      op: 90.0000036657751,
      st: 10.7475004377546,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/inline-loader-color.ts
var inlineLoaderColorData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 214,
  w: 200,
  h: 112,
  nm: "_Loading_horizontal",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Layer 6 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.127, 61.768, 0], ix: 2 },
        a: { a: 0, k: [67.987, 38.897, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [4.31, 12.068],
                    [-8.516, -1.548],
                    [4.442, -4.813],
                    [2.281, 13.167],
                    [5.048, -2.277]
                  ],
                  o: [
                    [0, 0],
                    [-1.935, -5.419],
                    [8.516, 1.549],
                    [-2.077, 2.251],
                    [-2.122, -12.245],
                    [0, 0]
                  ],
                  v: [
                    [28.331, 8.518],
                    [-2.492, -1.623],
                    [8.085, -13.817],
                    [11.545, 2.365],
                    [-13.564, 3.449],
                    [-26.331, -7.357]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 187.195,
                    s: [0]
                  },
                  { t: 212.2197265625, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.16], y: [1] },
                    o: { x: [0.38], y: [0] },
                    t: 157.999,
                    s: [0]
                  },
                  { t: 183.0244140625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.8, 0.607843137255, 0.454901960784, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.081, 38.897], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.407843137255, 0.36862745098, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.7, 34.3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.818, 0.818] },
                    o: { x: [0.167, 0.167], y: [0.182, 0.182] },
                    t: 157.999,
                    s: [0, 0]
                  },
                  { t: 163, s: [110, 110] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 157.1650390625,
      op: 214,
      st: 157.1650390625,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Layer 3 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [98.324, 49.628, 0], ix: 2 },
        a: { a: 0, k: [68.326, 35.646, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-7.572, -1.01],
                    [3.971, 8.237],
                    [2.906, -6.182],
                    [-14.709, 1.775],
                    [-12.934, 0.447],
                    [-2.214, -3.454]
                  ],
                  o: [
                    [0, 0],
                    [16.664, 2.223],
                    [-3.742, -7.761],
                    [-4.13, 8.787],
                    [18.568, -2.24],
                    [5.555, -0.192],
                    [5.885, 9.181]
                  ],
                  v: [
                    [-34.508, 3.523],
                    [-23.633, 11.714],
                    [-0.653, -8.009],
                    [-17.714, -6.975],
                    [3.891, 17.895],
                    [25.601, -7.996],
                    [35.37, 0.516]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.6], y: [1] },
                    o: { x: [0.81], y: [0] },
                    t: 128.804,
                    s: [0]
                  },
                  { t: 153.828125, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.14], y: [1] },
                    o: { x: [0.41], y: [0] },
                    t: 100.442,
                    s: [0]
                  },
                  { t: 125.466796875, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0, 0.227450996637, 0.4392157197, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.258, 35.645], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [0, 5.669],
                    [-5.67, 0],
                    [0, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.396078431373, 0.694117647059, 0.321568627451, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [109.684, 49.055], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.834, 0.834] },
                    o: { x: [0.167, 0.167], y: [0.166, 0.166] },
                    t: 100.442,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 105,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.835, 0.835] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 191,
                    s: [110, 110]
                  },
                  { t: 195.537109375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 99.607421875,
      op: 195.537109375,
      st: 99.607421875,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Layer 5 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100.609, 53.612, 0], ix: 2 },
        a: { a: 0, k: [67.97, 41.759, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [7.02, -14.552],
                    [-5.418, 9.846],
                    [10, 0]
                  ],
                  o: [
                    [0, 0],
                    [-10.681, 22.143],
                    [6.29, -11.429],
                    [-8.134, 0]
                  ],
                  v: [
                    [23.845, -3.468],
                    [1.377, 6.426],
                    [-19.219, 5.998],
                    [-28.179, -11.056]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.59], y: [0] },
                    t: 72.08,
                    s: [0]
                  },
                  { t: 97.10546875, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.25], y: [0] },
                    t: 44.553,
                    s: [0]
                  },
                  { t: 68.7431640625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.21960785985, 0.705882370472, 0.61960786581, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.97, 41.759], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.509803921569, 0.392156862745, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [27.016, 29.646], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.838, 0.838] },
                    o: { x: [0.167, 0.167], y: [0.162, 0.162] },
                    t: 44.553,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 49,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.848, 0.848] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 132.14,
                    s: [110, 110]
                  },
                  { t: 136.3115234375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 43.71875,
      op: 136.310546875,
      st: 44.552734375,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Layer 1 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.77, 57.554, 0], ix: 2 },
        a: { a: 0, k: [68.113, 36.77, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-12.162, -15.329],
                    [-0.351, 7.877],
                    [-10.918, -0.012],
                    [-15.581, 9.368]
                  ],
                  o: [
                    [8.109, 10.221],
                    [0.389, -8.726],
                    [14.198, 0.016],
                    [0, 0]
                  ],
                  v: [
                    [-29.463, 7.355],
                    [-12.149, 5.074],
                    [1.419, -13.754],
                    [27.738, 4.935]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 0.705882352941, 0.400000029919, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.78], y: [0] },
                    t: 23,
                    s: [0]
                  },
                  { t: 41, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.22], y: [1] },
                    o: { x: [0.6], y: [0] },
                    t: 2.503,
                    s: [0]
                  },
                  { t: 18.8291015625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.113, 36.77], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.67, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.40784317255, 0.549019634724, 0.729411780834, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [107.57, 34.139], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.824, 0.824] },
                    o: { x: [0.167, 0.167], y: [0.176, 0.176] },
                    t: 4.171,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 9,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.853, 0.853] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 77,
                    s: [110, 110]
                  },
                  { t: 81.0400390625, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.407843137255, 0.36862745098, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.706, 34.26], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.99, 0.99], y: [1, 0.997] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 19,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.842, 0.842] },
                    o: { x: [0.65, 0.65], y: [0, 0] },
                    t: 27,
                    s: [110, 110]
                  },
                  { t: 31.341796875, s: [0, 0] }
                ],
                ix: 3
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 88.421875,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/inline-loader-dark.ts
var inlineLoaderDarkData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 214,
  w: 200,
  h: 112,
  nm: "_Loading_horizontal 2",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Layer 6 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.127, 61.768, 0], ix: 2 },
        a: { a: 0, k: [67.987, 38.897, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [4.31, 12.068],
                    [-8.516, -1.548],
                    [4.442, -4.813],
                    [2.281, 13.167],
                    [5.048, -2.277]
                  ],
                  o: [
                    [0, 0],
                    [-1.935, -5.419],
                    [8.516, 1.549],
                    [-2.077, 2.251],
                    [-2.122, -12.245],
                    [0, 0]
                  ],
                  v: [
                    [28.331, 8.518],
                    [-2.492, -1.623],
                    [8.085, -13.817],
                    [11.545, 2.365],
                    [-13.564, 3.449],
                    [-26.331, -7.357]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 187.195,
                    s: [0]
                  },
                  { t: 212.2197265625, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.16], y: [1] },
                    o: { x: [0.38], y: [0] },
                    t: 157.999,
                    s: [0]
                  },
                  { t: 183.0244140625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.081, 38.897], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.7, 34.3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.818, 0.818] },
                    o: { x: [0.167, 0.167], y: [0.182, 0.182] },
                    t: 157.999,
                    s: [0, 0]
                  },
                  { t: 163, s: [110, 110] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 157.1650390625,
      op: 214,
      st: 157.1650390625,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Layer 3 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [98.324, 49.628, 0], ix: 2 },
        a: { a: 0, k: [68.326, 35.646, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-7.572, -1.01],
                    [3.971, 8.237],
                    [2.906, -6.182],
                    [-14.709, 1.775],
                    [-12.934, 0.447],
                    [-2.214, -3.454]
                  ],
                  o: [
                    [0, 0],
                    [16.664, 2.223],
                    [-3.742, -7.761],
                    [-4.13, 8.787],
                    [18.568, -2.24],
                    [5.555, -0.192],
                    [5.885, 9.181]
                  ],
                  v: [
                    [-34.508, 3.523],
                    [-23.633, 11.714],
                    [-0.653, -8.009],
                    [-17.714, -6.975],
                    [3.891, 17.895],
                    [25.601, -7.996],
                    [35.37, 0.516]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.6], y: [1] },
                    o: { x: [0.81], y: [0] },
                    t: 128.804,
                    s: [0]
                  },
                  { t: 153.828125, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.14], y: [1] },
                    o: { x: [0.41], y: [0] },
                    t: 100.442,
                    s: [0]
                  },
                  { t: 125.466796875, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.258, 35.645], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [0, 5.669],
                    [-5.67, 0],
                    [0, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [109.684, 49.055], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.834, 0.834] },
                    o: { x: [0.167, 0.167], y: [0.166, 0.166] },
                    t: 100.442,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 105,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.835, 0.835] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 191,
                    s: [110, 110]
                  },
                  { t: 195.537109375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 99.607421875,
      op: 195.537109375,
      st: 99.607421875,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Layer 5 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100.609, 53.612, 0], ix: 2 },
        a: { a: 0, k: [67.97, 41.759, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [7.02, -14.552],
                    [-5.418, 9.846],
                    [10, 0]
                  ],
                  o: [
                    [0, 0],
                    [-10.681, 22.143],
                    [6.29, -11.429],
                    [-8.134, 0]
                  ],
                  v: [
                    [23.845, -3.468],
                    [1.377, 6.426],
                    [-19.219, 5.998],
                    [-28.179, -11.056]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.59], y: [0] },
                    t: 72.08,
                    s: [0]
                  },
                  { t: 97.10546875, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.25], y: [0] },
                    t: 44.553,
                    s: [0]
                  },
                  { t: 68.7431640625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.97, 41.759], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [27.016, 29.646], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.838, 0.838] },
                    o: { x: [0.167, 0.167], y: [0.162, 0.162] },
                    t: 44.553,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 49,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.848, 0.848] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 132.14,
                    s: [110, 110]
                  },
                  { t: 136.3115234375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 43.71875,
      op: 136.310546875,
      st: 44.552734375,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Layer 1 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.77, 57.554, 0], ix: 2 },
        a: { a: 0, k: [68.113, 36.77, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-12.162, -15.329],
                    [-0.351, 7.877],
                    [-10.918, -0.012],
                    [-15.581, 9.368]
                  ],
                  o: [
                    [8.109, 10.221],
                    [0.389, -8.726],
                    [14.198, 0.016],
                    [0, 0]
                  ],
                  v: [
                    [-29.463, 7.355],
                    [-12.149, 5.074],
                    [1.419, -13.754],
                    [27.738, 4.935]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.78], y: [0] },
                    t: 23,
                    s: [0]
                  },
                  { t: 41, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.22], y: [1] },
                    o: { x: [0.6], y: [0] },
                    t: 2.503,
                    s: [0]
                  },
                  { t: 18.8291015625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.113, 36.77], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.67, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [107.57, 34.139], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.824, 0.824] },
                    o: { x: [0.167, 0.167], y: [0.176, 0.176] },
                    t: 4.171,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 9,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.853, 0.853] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 77,
                    s: [110, 110]
                  },
                  { t: 81.0400390625, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.706, 34.26], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.99, 0.99], y: [1, 0.997] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 19,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.842, 0.842] },
                    o: { x: [0.65, 0.65], y: [0, 0] },
                    t: 27,
                    s: [110, 110]
                  },
                  { t: 31.341796875, s: [0, 0] }
                ],
                ix: 3
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 88.421875,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/inline-loader-light.ts
var inlineLoaderLightData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 214,
  w: 200,
  h: 112,
  nm: "_Loading_horizontal 3",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Layer 6 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.127, 61.768, 0], ix: 2 },
        a: { a: 0, k: [67.987, 38.897, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [4.31, 12.068],
                    [-8.516, -1.548],
                    [4.442, -4.813],
                    [2.281, 13.167],
                    [5.048, -2.277]
                  ],
                  o: [
                    [0, 0],
                    [-1.935, -5.419],
                    [8.516, 1.549],
                    [-2.077, 2.251],
                    [-2.122, -12.245],
                    [0, 0]
                  ],
                  v: [
                    [28.331, 8.518],
                    [-2.492, -1.623],
                    [8.085, -13.817],
                    [11.545, 2.365],
                    [-13.564, 3.449],
                    [-26.331, -7.357]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.61], y: [1] },
                    o: { x: [0.85], y: [0] },
                    t: 187.195,
                    s: [0]
                  },
                  { t: 212.2197265625, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.16], y: [1] },
                    o: { x: [0.38], y: [0] },
                    t: 157.999,
                    s: [0]
                  },
                  { t: 183.0244140625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.081, 38.897], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.7, 34.3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.818, 0.818] },
                    o: { x: [0.167, 0.167], y: [0.182, 0.182] },
                    t: 157.999,
                    s: [0, 0]
                  },
                  { t: 163, s: [110, 110] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 157.1650390625,
      op: 214,
      st: 157.1650390625,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Layer 3 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [98.324, 49.628, 0], ix: 2 },
        a: { a: 0, k: [68.326, 35.646, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-7.572, -1.01],
                    [3.971, 8.237],
                    [2.906, -6.182],
                    [-14.709, 1.775],
                    [-12.934, 0.447],
                    [-2.214, -3.454]
                  ],
                  o: [
                    [0, 0],
                    [16.664, 2.223],
                    [-3.742, -7.761],
                    [-4.13, 8.787],
                    [18.568, -2.24],
                    [5.555, -0.192],
                    [5.885, 9.181]
                  ],
                  v: [
                    [-34.508, 3.523],
                    [-23.633, 11.714],
                    [-0.653, -8.009],
                    [-17.714, -6.975],
                    [3.891, 17.895],
                    [25.601, -7.996],
                    [35.37, 0.516]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.6], y: [1] },
                    o: { x: [0.81], y: [0] },
                    t: 128.804,
                    s: [0]
                  },
                  { t: 153.828125, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.14], y: [1] },
                    o: { x: [0.41], y: [0] },
                    t: 100.442,
                    s: [0]
                  },
                  { t: 125.466796875, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [67.258, 35.645], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [0, 5.669],
                    [-5.67, 0],
                    [0, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [109.684, 49.055], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.834, 0.834] },
                    o: { x: [0.167, 0.167], y: [0.166, 0.166] },
                    t: 100.442,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 105,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.835, 0.835] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 191,
                    s: [110, 110]
                  },
                  { t: 195.537109375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 99.607421875,
      op: 195.537109375,
      st: 99.607421875,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Layer 5 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100.609, 53.612, 0], ix: 2 },
        a: { a: 0, k: [67.97, 41.759, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [7.02, -14.552],
                    [-5.418, 9.846],
                    [10, 0]
                  ],
                  o: [
                    [0, 0],
                    [-10.681, 22.143],
                    [6.29, -11.429],
                    [-8.134, 0]
                  ],
                  v: [
                    [23.845, -3.468],
                    [1.377, 6.426],
                    [-19.219, 5.998],
                    [-28.179, -11.056]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.59], y: [0] },
                    t: 72.08,
                    s: [0]
                  },
                  { t: 97.10546875, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.15], y: [1] },
                    o: { x: [0.25], y: [0] },
                    t: 44.553,
                    s: [0]
                  },
                  { t: 68.7431640625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.97, 41.759], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [27.016, 29.646], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.838, 0.838] },
                    o: { x: [0.167, 0.167], y: [0.162, 0.162] },
                    t: 44.553,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 49,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.848, 0.848] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 132.14,
                    s: [110, 110]
                  },
                  { t: 136.3115234375, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 43.71875,
      op: 136.310546875,
      st: 44.552734375,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Layer 1 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [99.77, 57.554, 0], ix: 2 },
        a: { a: 0, k: [68.113, 36.77, 0], ix: 1 },
        s: { a: 0, k: [200, 200, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-12.162, -15.329],
                    [-0.351, 7.877],
                    [-10.918, -0.012],
                    [-15.581, 9.368]
                  ],
                  o: [
                    [8.109, 10.221],
                    [0.389, -8.726],
                    [14.198, 0.016],
                    [0, 0]
                  ],
                  v: [
                    [-29.463, 7.355],
                    [-12.149, 5.074],
                    [1.419, -13.754],
                    [27.738, 4.935]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 9, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.59], y: [1] },
                    o: { x: [0.78], y: [0] },
                    t: 23,
                    s: [0]
                  },
                  { t: 41, s: [100] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.22], y: [1] },
                    o: { x: [0.6], y: [0] },
                    t: 2.503,
                    s: [0]
                  },
                  { t: 18.8291015625, s: [100] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 3,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [68.113, 36.77], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.67, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [107.57, 34.139], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.824, 0.824] },
                    o: { x: [0.167, 0.167], y: [0.176, 0.176] },
                    t: 4.171,
                    s: [0, 0]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [1, 1] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 9,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.853, 0.853] },
                    o: { x: [0.61, 0.61], y: [0, 0] },
                    t: 77,
                    s: [110, 110]
                  },
                  { t: 81.0400390625, s: [0, 0] }
                ],
                ix: 3,
                x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -3.131],
                    [3.131, 0],
                    [0, 3.131],
                    [-3.131, 0]
                  ],
                  o: [
                    [0, 3.131],
                    [-3.131, 0],
                    [0, -3.131],
                    [3.131, 0]
                  ],
                  v: [
                    [5.669, 0],
                    [1e-3, 5.669],
                    [-5.669, 0],
                    [1e-3, -5.669]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [28.706, 34.26], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.99, 0.99], y: [1, 0.997] },
                    o: { x: [0.167, 0.167], y: [0, 0] },
                    t: 19,
                    s: [110, 110]
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.842, 0.842] },
                    o: { x: [0.65, 0.65], y: [0, 0] },
                    t: 27,
                    s: [110, 110]
                  },
                  { t: 31.341796875, s: [0, 0] }
                ],
                ix: 3
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 88.421875,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/spinner-color.ts
var spinnerColorData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 1.1.0", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 161,
  w: 1e3,
  h: 1e3,
  nm: "_Spinner_color",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "Null 4",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [500, 500, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [500, 500, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 161,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 8",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, 0, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.517647058824, 0.811764705882, 0.760784313725, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 145,
                s: [0]
              },
              { t: 160, s: [52] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 125,
                s: [0]
              },
              { t: 140, s: [52] }
            ],
            ix: 2
          },
          o: { a: 0, k: 280, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 120,
      op: 161,
      st: 120,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 6",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, 0, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.945098039216, 0.76862745098, 0, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 105,
                s: [0]
              },
              { t: 120, s: [70] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 85,
                s: [0]
              },
              { t: 100, s: [70] }
            ],
            ix: 2
          },
          o: { a: 0, k: -23, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 80,
      op: 120,
      st: 80,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 4",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, 0, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.407843137255, 0.549019607843, 0.729411764706, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 65,
                s: [0]
              },
              { t: 80, s: [55] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 45,
                s: [0]
              },
              { t: 60, s: [55] }
            ],
            ix: 2
          },
          o: { a: 0, k: 89, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 40,
      op: 80,
      st: 40,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 2",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, 0, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.011764705882, 0.490196078431, 0.403921568627, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 25,
                s: [0]
              },
              { t: 40, s: [66] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 5,
                s: [0]
              },
              { t: 20, s: [66] }
            ],
            ix: 2
          },
          o: { a: 0, k: 158, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 0,
      op: 40,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Shape Layer 9",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [56.707, 50.076, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 125,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 130,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 185,
              s: [100, 100, 100]
            },
            { t: 190, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.705882352941, 0.4, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 125,
      op: 161,
      st: 125,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Shape Layer 7",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-73.355, 20.763, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 85,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 90,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 145,
              s: [100, 100, 100]
            },
            { t: 150, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.227450980392, 0.439215686275, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 85,
      op: 150,
      st: 85,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Shape Layer 5",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-57.355, -51.237, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 45,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 50,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 105,
              s: [100, 100, 100]
            },
            { t: 110, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.219607843137, 0.705882352941, 0.619607843137, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 45,
      op: 110,
      st: 45,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Shape Layer 3",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [67.145, -34.737, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 5,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 10,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 65,
              s: [100, 100, 100]
            },
            { t: 70, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.988235294118, 0.925490196078, 0.596078431373, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 5,
      op: 70,
      st: 5,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Shape Layer 1",
      parent: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [56.645, 50.013, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 25,
              s: [100, 100, 100]
            },
            { t: 30, s: [0, 0, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 0.705882352941, 0.4, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 30,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/spinner-dark.ts
var spinnerDarkData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 1.1.0", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 161,
  w: 200,
  h: 200,
  nm: "_Spinner",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 8",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 145,
                s: [0]
              },
              { t: 160, s: [52] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 125,
                s: [0]
              },
              { t: 140, s: [52] }
            ],
            ix: 2
          },
          o: { a: 0, k: 280, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 120,
      op: 161,
      st: 120,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 105,
                s: [0]
              },
              { t: 120, s: [70] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 85,
                s: [0]
              },
              { t: 100, s: [70] }
            ],
            ix: 2
          },
          o: { a: 0, k: -23, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 80,
      op: 120,
      st: 80,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 65,
                s: [0]
              },
              { t: 80, s: [55] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 45,
                s: [0]
              },
              { t: 60, s: [55] }
            ],
            ix: 2
          },
          o: { a: 0, k: 89, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 40,
      op: 80,
      st: 40,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 25,
                s: [0]
              },
              { t: 40, s: [66] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 5,
                s: [0]
              },
              { t: 20, s: [66] }
            ],
            ix: 2
          },
          o: { a: 0, k: 158, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 0,
      op: 40,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Shape Layer 9",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [156.707, 150.076, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 125,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 130,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 17.667] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 185,
              s: [100, 100, 100]
            },
            { t: 190, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 125,
      op: 161,
      st: 125,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Shape Layer 7",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [26.645, 120.763, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 85,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 90,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 17.667] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 145,
              s: [100, 100, 100]
            },
            { t: 150, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 85,
      op: 150,
      st: 85,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Shape Layer 5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [42.645, 48.763, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 45,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 50,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 17.667] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 105,
              s: [100, 100, 100]
            },
            { t: 110, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 45,
      op: 110,
      st: 45,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Shape Layer 3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [167.145, 65.263, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 5,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 10,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 17.667] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 65,
              s: [100, 100, 100]
            },
            { t: 70, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: "Scale - Overshoot",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Bounce",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          ty: 5,
          nm: "Scale - Friction",
          np: 3,
          mn: "ADBE Slider Control",
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Slider",
              mn: "ADBE Slider Control-0001",
              ix: 1,
              v: {
                a: 0,
                k: 60,
                ix: 1,
                x: "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 5,
      op: 70,
      st: 5,
      bm: 0
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Shape Layer 1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [156.645, 150.013, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 17.667] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 25,
              s: [100, 100, 100]
            },
            { t: 30, s: [0, 0, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.16862745098, 0.16862745098, 0.172549019608, 1],
                ix: 4
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 30,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

// src/animation-data/spinner-light.ts
var spinnerLightData = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 2.0.4", a: "", k: "", d: "", tc: "" },
  fr: 25,
  ip: 0,
  op: 161,
  w: 200,
  h: 200,
  nm: "_Spinner 2",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 8",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 145,
                s: [0]
              },
              { t: 160, s: [52] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 125,
                s: [0]
              },
              { t: 140, s: [52] }
            ],
            ix: 2
          },
          o: { a: 0, k: 280, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 120,
      op: 161,
      st: 120,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 105,
                s: [0]
              },
              { t: 120, s: [70] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 85,
                s: [0]
              },
              { t: 100, s: [70] }
            ],
            ix: 2
          },
          o: { a: 0, k: -23, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 80,
      op: 120,
      st: 80,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 65,
                s: [0]
              },
              { t: 80, s: [55] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 45,
                s: [0]
              },
              { t: 60, s: [55] }
            ],
            ix: 2
          },
          o: { a: 0, k: 89, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 40,
      op: 80,
      st: 40,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [151.516, 151.516], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 20, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, -8e-3], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        },
        {
          ty: "tm",
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.75], y: [1] },
                o: { x: [0.81], y: [0] },
                t: 25,
                s: [0]
              },
              { t: 40, s: [66] }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.19], y: [1] },
                o: { x: [0.36], y: [0] },
                t: 5,
                s: [0]
              },
              { t: 20, s: [66] }
            ],
            ix: 2
          },
          o: { a: 0, k: 158, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false
        }
      ],
      ip: 0,
      op: 40,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 9",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [156.707, 150.076, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
              t: 125,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 130,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 185,
              s: [100, 100, 100]
            },
            { t: 190, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 125,
      op: 161,
      st: 125,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Shape Layer 7",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [26.645, 120.763, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
              t: 85,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 90,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 145,
              s: [100, 100, 100]
            },
            { t: 150, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 85,
      op: 150,
      st: 85,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Shape Layer 5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [42.645, 48.763, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
              t: 45,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 50,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 105,
              s: [100, 100, 100]
            },
            { t: 110, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 45,
      op: 110,
      st: 45,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Shape Layer 3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [167.145, 65.263, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
              t: 5,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 10,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 65,
              s: [100, 100, 100]
            },
            { t: 70, s: [0, 0, 100] }
          ],
          ix: 6,
          x: "var $bm_rt;\nvar $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : sub(time, key(n).time), $bm_rt = $bm_rt = 0 < n ? (v = velocityAtTime(sub(key(n).time, div(thisComp.frameDuration, 10))), add(value, div(mul(mul(div(v, 100), amp), Math.sin(mul(mul(mul(freq, t), 2), Math.PI))), Math.exp(mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 5,
      op: 70,
      st: 5,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Shape Layer 1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [156.645, 150.013, 0], ix: 2 },
        a: { a: 0, k: [37.895, 50.263, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
              o: { x: [0.61, 0.61, 0.61], y: [0, 0, 0] },
              t: 25,
              s: [100, 100, 100]
            },
            { t: 30, s: [0, 0, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [25.789, 25.789], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [37.895, 50.263], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 30,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  contentLoaderData,
  fullScreenLoaderBlackData,
  fullScreenLoaderWhiteData,
  inlineLoaderColorData,
  inlineLoaderDarkData,
  inlineLoaderLightData,
  spinnerColorData,
  spinnerDarkData,
  spinnerLightData
});
